<ng-container *ngIf="model">
  <!-- Medium and large devices layout -->
  <div class="row no-gutters my-4 h-100 hidden-xs hidden-sm mb-product-line-search-result-wrapper"
       data-cy="mb-search-product-line-wrapper">

    <!--  If model is variant display search result item  -->
    <div *ngIf="isVariant"
         class="col-12">
      <mb-search-result-item [model]="firstVariant"></mb-search-result-item>
    </div>

    <!--  If model is family display family line  -->
    <ng-container *ngIf="!isVariant">
      <div class="mt-1 pl-3 position-static"
           [ngClass]="(isFacetExpanded$ | async) && 'mb-search-facet-expanded-product-family-line' || 'mb-search-product-family-line'"
           data-cy="mb-search-family-line-name">
        <div class="cursor-pointer">
          <a [routerLink]="url"
             [fragment]="fragment">
            <strong [innerHTML]="model.name" [mbProductClick]="model" [attr.data-analytics-src]="dataAnalyticsClickSource" data-analytics="product-title"></strong>
          </a>
        </div>
        <div class="tw-mb-2">
          <span *ngIf="firstVariant?.alternativeNames" class="tw-italic">{{'mbproduct.synonyms'|mbTranslate}}: {{firstVariant.alternativeNames.join(', ')}}</span>
        </div>
        <p *ngIf="regulatoryStatus$ | async as regulatoryStatus"
           class="mb-family-line-rstatus"
           data-cy="mb-search-family-line-rstatus"
           [innerHTML]="regulatoryStatus">
        </p>
      </div>

      <ng-container *ngFor="let info of model.searchInformationMap?.entry">
        <div class="col mt-1"
             [ngClass]="(isFacetExpanded$ | async) && 'mb-search-dynamic-column-padding-left' || 'pl-3'">
          <span class="mb-family-line-keys text-left" [innerHTML]="info?.key"></span>
          <br/>
          <span class="mb-family-line-values" [innerHTML]="info?.value"></span>
        </div>
      </ng-container>

      <div *ngIf="!model.searchInformationMap?.entry" class="col mt-1"></div>

      <div class="mb-search-dynamic-column-padding-left text-left mt-1"
           [ngClass]="(isFacetExpanded$ | async) && 'mb-search-facet-expanded-product-price' || 'mb-one-and-half-column-width'"
           data-cy="mb-search-family-line-price">
        <span *ngIf="!hasPriceOnRequest" class="mb-family-line-keys text-left">{{ 'searchResultItem.priceFrom' | mbTranslate }}</span>
        <br/>
        <span><strong [innerHTML]="model.price?.formattedValue | safeHtml"></strong></span>
      </div>

      <div class="col-2 ml-auto mt-1 pr-md-1 pr-lg-3 text-right">
        <button *ngIf="areResultsCollapsed"
                class="btn btn-sm mr-1 mb-1 mt-md-2 mt-lg-0 mb-family-line-buttons expand-family-line"
                type="submit"
                data-cy="mb-search-family-line-expand-button"
                [ngClass]="(isFacetExpanded$ | async) && 'mb-search-family-line-shrink' || ''"
                (click)="handleExpandButtonClick()">
          <img src="../../../assets/icons/svg/arrow_down_transparent_background.svg"
               title="Expand"
               alt="Expand icon"
               aria-label="Expand icon"
               data-cy="mb-search-expand-family-line-icon"/>
        </button>

        <button *ngIf="!areResultsCollapsed"
                type="submit"
                data-cy="mb-search-family-line-collapse-button"
                class="btn btn-sm mr-1 mb-1 mt-md-2 mt-lg-0 mb-family-line-buttons expand-family-line"
                [ngClass]="(isFacetExpanded$ | async) && 'mb-search-family-line-shrink' || ''"
                (click)="handleExpandButtonClick()">
          <img src="../../../assets/icons/svg/arrow_up_transparent_background.svg"
               title="Expand"
               alt="Expand icon"
               aria-label="Expand icon"
               data-cy="mb-search-expand-family-line-icon"/>
        </button>
      </div>

      <div [ngClass]="[!areResultsCollapsed ? 'd-grid' : '', 'col-12']"
           [@smoothCollapse]="areResultsCollapsed ? 'initial' : 'final'">
        <ng-container *ngFor="let variant of model.variantOptions, index as i">
          <div [ngClass]="[i === 0 ? 'mb-search-first-variant-child' : '', 'col-12 my-3 px-0']">
            <mb-search-result-item [model]="variant"
                                   [isChild]="true">
            </mb-search-result-item>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>


  <!-- Small devices layout -->
  <div class="row no-gutters my-4 h-100 hidden-md hidden-lg hidden-xl mb-product-line-search-result-wrapper"
       data-cy="mb-search-product-line-wrapper-sm">

    <!--  If model is variant display search result item  -->
    <div *ngIf="isVariant"
         class="col-12">
      <mb-search-result-item [model]="firstVariant"></mb-search-result-item>
    </div>

    <!--  If model is family display family line  -->
    <ng-container *ngIf="!isVariant">
      <div class="col-12 my-auto position-static">
        <div class="row no-gutters my-1 pb-3"
             data-cy="mb-search-family-line-headline-sm">
          <div class="col-12 px-2"
               data-cy="mb-search-family-line-name-sm">
            <div class="cursor-pointer">
              <a [routerLink]="url"
                 [fragment]="fragment">
                <strong [innerHTML]="model.name" [mbProductClick]="model" [attr.data-analytics-src]="dataAnalyticsClickSource" data-analytics="product-title"></strong>
              </a>
            </div>
          </div>
          <div class="col-12 px-2 tw-mb-2">
            <span *ngIf="firstVariant?.alternativeNames" class="tw-italic">{{'mbproduct.synonyms'|mbTranslate}}: {{firstVariant.alternativeNames.join(', ')}}</span>
          </div>
          <div *ngIf="regulatoryStatus$ | async as regulatoryStatus"
               class="col-12 px-2 position-static">
            <p class="mb-family-line-rstatus"
               data-cy="mb-search-family-line-rstatus-sm"
               [innerHTML]="regulatoryStatus">
            </p>
          </div>
        </div>

        <div class="row no-gutters my-1"
             data-cy="mb-search-product-line-size-sm"
             *ngFor="let info of model.searchInformationMap?.entry">
          <div class="col-6 px-2">
            <p class="mb-0 mb-family-line-keys" [innerHTML]="info?.key"></p>
          </div>
          <div class="col-6 px-2 mb-family-line-values">
            <p class="mb-0" [innerHTML]="info?.value"></p>
          </div>
        </div>

        <div *ngIf="!hasPriceOnRequest"
             class="row no-gutters my-1"
             data-cy="mb-search-family-line-price-sm">
          <div class="col-6 my-auto px-2">
            <p class="mb-0 mb-family-line-keys">{{'searchResultItem.priceFrom' | mbTranslate}}</p>
          </div>
          <div class="col-6 my-auto px-2 mb-family-line-values">
            <p class="mb-0">
              <strong [innerHTML]="model.price?.formattedValue | safeHtml"></strong>
            </p>
          </div>
        </div>

        <div class="row no-gutters my-1">
          <div class="col-12 my-auto px-2 text-center"
               data-cy="mb-search-product-line-actions-sm">
            <button *ngIf="areResultsCollapsed"
                    type="submit"
                    class="btn btn-sm mr-1 mb-1 mt-md-2 mt-lg-0 mb-family-line-buttons expand-family-line"
                    data-cy="mb-search-family-line-expand-button"
                    (click)="handleExpandButtonClick()">
              <img src="../../../assets/icons/svg/arrow_down_transparent_background.svg"
                   title="Expand"
                   alt="Expand icon"
                   aria-label="Expand icon"
                   data-cy="mb-search-expand-family-line-icon"/>
            </button>

            <button *ngIf="!areResultsCollapsed"
                    type="submit"
                    class="btn btn-sm mr-1 mb-1 mt-md-2 mt-lg-0 mb-family-line-buttons expand-family-line"
                    data-cy="mb-search-family-line-collapse-button"
                    (click)="handleExpandButtonClick()">
              <img src="../../../assets/icons/svg/arrow_up_transparent_background.svg"
                   title="Expand"
                   alt="Expand icon"
                   aria-label="Expand icon"
                   data-cy="mb-search-expand-family-line-icon"/>
            </button>
          </div>
        </div>

        <div [ngClass]="[!areResultsCollapsed ? 'd-flex' : '', 'row no-gutters my-1']"
             [@smoothCollapse]="areResultsCollapsed ? 'initial' : 'final'">
          <ng-container *ngFor="let variant of model.variantOptions">
            <div class="col-12 mt-4 mb-2">
              <mb-search-result-item [model]="variant"
                                     [isChild]="true">
              </mb-search-result-item>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>

</ng-container>

